import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
export function SearchPageGridSkeleton() {
    return (React.createElement(Skeleton, { skeletonProps: {
            height: 1200,
        } }));
}
